import React, { useEffect, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import CheckIcon from "assets/svgIcons/CheckIcon";
import UnCheckIcon from "assets/svgIcons/UncheckIcon";
import CampaignsTable from "pages/Ads/Campaigns/CampaignsTable";
import {
  CenteredLoader,
  StyledCheckbox,
} from "commonComponents/FormElement/Checkbox/CheckboxStyled";
import { CircleBtn, PopUpContainer } from "assets/css/globle";
import CheckRoundIcon from "assets/svgIcons/CheckRoundIcon";
import EditRoundIcon from "assets/svgIcons/EditRoundIcon";
import UpArrowRoundIcon from "assets/svgIcons/UpArrowRoundIcon";
import CloseRoundIcon from "assets/svgIcons/CloseRoundIcon";
import DeleteIcon from "assets/svgIcons/DeleteIcon";
import ResendIcon from "assets/svgIcons/ResendIcon";
import HelpIcon from "assets/svgIcons/HelpIcon";
import CalendarSection from "./Calender/index";
import _ from "lodash";
import {
  Container,
  Header,
  Wrapper,
  Section,
  BodySection,
  TableSection,
  Info,
  DataSection,
} from "pages/Ads/Campaigns/CampaignsStyled";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useHookstate } from "@hookstate/core";
import {
  ADS_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import { Modal, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import Link from "@mui/material/Link";
import { Loader } from "commonComponents/Loader/Loader";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { API_STATUSES } from "redux/_helpers/statuses";
import {
  getFeatureSetOption,
  getFeaturesList,
  isUserReadOnly,
} from "../../../constant";

const Campaigns = () => {
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const [selectedRow, setSelectedRow] = useState([]);
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openPublish, setOpenPublish] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const handlePublishOpen = () => setOpenPublish(true);
  const handleOpen = () => setOpen(true);
  const handleDeleteClose = () => setOpenDelete(false);
  const handlePublishClose = () => setOpenPublish(false);
  const handleClose = () => setOpen(false);
  const { t } = useTranslation();
  const [storeId, setStoreId] = useState();
  const [rowSiteId, setRowSiteId] = useState();

  const dispatch = useDispatch();

  const { publishNowCount, shouldShowPublishNow } = useHookstate(ADS_GLOBAL_STATE);
  const {
    publishSiteStatus,
    siteSettingDataReduxStateStatus,
    siteSettingsData,
    getUserRole,
    getCampaignsStateData
  } = useSelector((state) => state.commonReducers);

  const campaignData = useSelector((state) => state?.commonReducers?.getCampaignsStateData) || [];

  const [campaign, setCampaign] = useState([]);
  const [pastCampaignCheckbox, setPastCampaignCheckBox] = useState(JSON.parse(localStorage.getItem("pastCampaignCheckbox")) === null ? false : JSON.parse(localStorage.getItem("pastCampaignCheckbox")));
  const [tournamentCampaignsCheckBox, setTournamentCampaignsCheckbox] = useState(JSON.parse(localStorage.getItem("tournamentCampaignsCheckBox")) === null ? false : JSON.parse(localStorage.getItem("tournamentCampaignsCheckBox")));
  const [manifestModal, setManifestModal] = useState(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "400px",
    width: "100%",
    bgcolor: "#fff",
    borderRadius: "5px",
    overflow: "hidden",
  };

  useEffect(() => {
    if(Object.keys(campaignData).length > 0) {
      sortAndFilter(false, "");
    }
  }, [campaignData]);

  useEffect(() => {
    if (getCampaignsStateData === null) {
      setManifestModal(true);
    }
  }, [getCampaignsStateData]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getCampaignsServices(siteId.get())).then(() => {
      setIsLoading(false);
    });
  }, [siteId.get()]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getBaseCampaignServices(siteId.get()));
  }, [siteId.get()]);

  function sortAndFilter(checked, isFrom) {
    let tournamentCampaigns = tournamentCampaignsCheckBox;
    let pastCampaigns = pastCampaignCheckbox;
    if (isFrom === "tournamentCampaigns") {
      tournamentCampaigns = checked;
      setTournamentCampaignsCheckbox(checked);
      localStorage.setItem("tournamentCampaignsCheckBox", JSON.stringify(checked));
    }

    if (isFrom === "pastCampaigns") {
      pastCampaigns = checked;
      setPastCampaignCheckBox(checked);
      localStorage.setItem("pastCampaignCheckbox", JSON.stringify(checked));
    }

    let now = moment.utc();
    const list = Object.values(campaignData?.campaigns).filter(campaign => {
      if (!tournamentCampaigns && campaign.tournamentId) {
        return false;
      }
    
      if (!campaign.startDateUtc || pastCampaigns) {
        return true;
      }
    
      const end = moment.utc(campaign.endDateUtc).add(1, 'd');
      return end.isAfter(now);  
    });
    
    setCampaign(list);
  }

  function refresh() {
    setIsLoading(true);
    
    dispatch(COMMON_SERVICES.getCampaignsServices(siteId.get())).then(() => {
      setIsLoading(false);
    });
  }
  //################ MULTIPLE DELETE FUNCTIONALITY#########//

  const handelMultipleDeleteButton = () => {
    setIsLoading(true); 
    setOpenDelete(false);

    const payload = {
      CampaignIds: selectedRow,
    };

    dispatch(
      COMMON_SERVICES.deleteMultipleCampaignServices(payload, siteId.get())
    ).then(() => {
      dispatch(COMMON_SERVICES.getCampaignsServices(siteId.get()));

      setIsLoading(false);
    });
  };

  const handleMultipleDeleteButtonFunction = (siteId, selectedRow) => {
    setOpenDelete(true);
    setStoreId(selectedRow);
    setRowSiteId(siteId.get());
  };

  function addNewCampaign() {
    setIsLoading(true);

    dispatch(
      COMMON_SERVICES.addNewCampaignServices(siteId.get())).then(() => {
      dispatch(COMMON_SERVICES.getWelcomeAdsImageServices(siteId.get()));
      dispatch(COMMON_SERVICES.getCampaignsServices(siteId.get())).then(() => {
        setIsLoading(false);
      });
    });
  }

  const chooseMessage = (count) => {
    publishNowCount.set(count);
  };

  function handlePublishReq() {
    shouldShowPublishNow.set(false);
    setOpenPublish(false);
    
    dispatch(
      COMMON_SERVICES.publishCampaignServices({ siteId: Number(siteId.get()) })
    ).then(() => {
      if (publishSiteStatus) {
        dispatch(COMMON_SERVICES.getCampaignsServices(siteId.get()));
      }
    });
  }

  if (siteSettingDataReduxStateStatus === API_STATUSES.REQUEST) {
    return <Loader />;
  }

  return (
    <Container>
      <Header>
        <div className="border-right">
          <StyledCheckbox className="checkbox">
            <Tooltip title={t("Show_past_campaigns")}>
              <FormControlLabel
                label={t("Show_past_campaigns")}
                control={
                  <Checkbox
                    defaultChecked={pastCampaignCheckbox}
                    onClick={(e) =>
                      sortAndFilter(e.target.checked, "pastCampaigns")
                    }
                    icon={<UnCheckIcon width={20} height={20} />}
                    checkedIcon={<CheckIcon width={20} height={20} />}
                  />
                }
              />
            </Tooltip>
          </StyledCheckbox>
        </div>
        <StyledCheckbox className="checkbox">
          <Tooltip title={t("Show_tournament_campaigns")}>
            <FormControlLabel
              label={t("Show_tournament_campaigns")}
              control={
                <Checkbox
                  style={
                    getFeatureSetOption(
                      siteSettingsData && siteSettingsData?.Features,
                      getFeaturesList().tournament_scoring,
                      getFeaturesList().adman_event
                    )
                      ? { backgroundColor: "#d3d3d3" }
                      : {}
                  }
                  disabled={getFeatureSetOption(
                    siteSettingsData?.Features,
                    getFeaturesList().tournament_scoring,
                    getFeaturesList().adman_event
                  )}
                  defaultChecked={tournamentCampaignsCheckBox}
                  onClick={(e) =>
                    sortAndFilter(e.target.checked, "tournamentCampaigns")
                  }
                  icon={<UnCheckIcon width={20} height={20} />}
                  checkedIcon={<CheckIcon width={20} height={20} />}
                />
              }
            />
          </Tooltip>
        </StyledCheckbox>
      </Header>
      <Wrapper>
        <Section>
          <div className="section-header">
            <h4>{t("Campaigns")}</h4>
            <div className="action-wrapper">
              <Tooltip title={t("Add_new_campaign")}>
                  <CircleBtn
                    disabled={
                      isUserReadOnly(getUserRole && getUserRole?.Role)
                    }
                    className="toolTip"
                    onClick={() => { addNewCampaign(); }}
                  >
                    + {t("Add_new_campaign")}{" "}
                  </CircleBtn>
              </Tooltip>

              <Tooltip title={t("Delete_Campaign")}>
                  <CircleBtn
                    disabled={
                      isUserReadOnly(getUserRole && getUserRole?.Role)
                    }
                    className="toolTip"
                    onClick={() =>
                      selectedRow?.length > 0
                        ? handleMultipleDeleteButtonFunction()
                        : ""
                    }
                  >
                    <DeleteIcon color={"#000"} />
                    {t("Delete_Campaign")}
                  </CircleBtn>
              </Tooltip>

              <Modal
                open={openDelete}
                onClose={handleDeleteClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <PopUpContainer>
                    <h2>{t("Confirm")}</h2>
                    <p>
                      {t(
                        "Are_you_sure_you_want_to_delete_the_selected_Campaigns"
                      )}
                    </p>
                    <div className="action-btn">
                      <button
                        onClick={() =>
                          handelMultipleDeleteButton(storeId, rowSiteId)
                        }
                        className="primary"
                      >
                        {t("Yes")}
                      </button>
                      <button onClick={() => setOpenDelete(false)}>
                        {t("No")}
                      </button>
                    </div>
                  </PopUpContainer>
                </Box>
              </Modal>
              <Modal
                open={manifestModal}
                onClose={() => setManifestModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <PopUpContainer>
                    <h2>{t("Load_failed")}</h2>
                    <p>
                      {t("Could_not_load_campaigns_(no_manifest_created_yet?)")}
                    </p>
                    <div className="action-btn">
                      <button
                        className="primary"
                        onClick={() => setManifestModal(false)}
                      >
                        {t("Ok")}
                      </button>
                    </div>
                  </PopUpContainer>
                </Box>
              </Modal>
              <Tooltip title={t("Help")}>
                <CircleBtn className="toolTip" onClick={handleOpen}>
                  <HelpIcon color="#1d1d1d" />
                  {t("Help")}
                </CircleBtn>
              </Tooltip>
              <Tooltip title={t("Refresh")}>
                <CircleBtn className="toolTip" onClick={refresh}>
                  <ResendIcon />
                  {t("Refresh")}
                </CircleBtn>
              </Tooltip>
            </div>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <PopUpContainer>
                  <h2 className="header">{t("Tutorial")}</h2>
                  <p className="p-inline-15">
                    Click here to view the{" "}
                    <Link
                      href="http://www.visagehelp.com/training/Advertising.html"
                      underline="none"
                      target="_blank"
                    >
                      {t("Ad_Manager_Tutorial")}
                    </Link>{" "}
                    at VisageHelp.com.
                  </p>
                  <h3 className="p-inline-15 text-center mb-10">
                    {t("Ad_File_Requirements")}
                  </h3>
                  <p className="p-inline-15">
                    Click here to{" "}
                    <Link
                      href="http://www.visagehelp.com/downloads/Visage-Advertising-Quick-Guide.pdf"
                      underline="none"
                      target="_blank"
                    >
                      download a document
                    </Link>{" "}
                    showing the size and formats required for advertising files,
                    and for advice on best practices
                  </p>
                  <div className="action-btn">
                    <button className="cancel" onClick={handleClose}>
                      {t("Close")}
                    </button>
                  </div>
                </PopUpContainer>
              </Box>
            </Modal>
          </div>

          <BodySection>
            <Info>
              <div>
                <CheckRoundIcon />
                {t("published")}
              </div>
              <div>
                <EditRoundIcon />
                {t("published_then_modified")}
              </div>
              <div>
                <UpArrowRoundIcon />
                {t("pending_publication")}
              </div>
              <div>
                <CloseRoundIcon />
                {t("Pending_publication_but_cant")}
              </div>
            </Info>
            {!isLoading ? (
              <DataSection>
                <div className="inner-data-section">
                  <TableSection>
                    <CampaignsTable
                      setSelectedRow={setSelectedRow}
                      selectedRow={selectedRow}
                      convertedData={campaign}
                      campaignData={campaignData}
                      chooseMessage={chooseMessage}
                    />
                  </TableSection>

                  {shouldShowPublishNow.get() || publishNowCount.get() !== 0 ? (
                    <>
                      <p className="publish-data-text">
                        {t("PendingPublication")}. {t("ClickPublish")}.
                      </p>
                      <Tooltip
                        title={t(
                          "Publish_worksheet,_start_sending_ads_to_cars"
                        )}
                        className="title"
                      >
                        <CircleBtn
                          className="tooltip"
                          disabled= {isUserReadOnly(getUserRole && getUserRole?.Role)}
                          style={
                             {
                                  marginRight: "13px",
                                  marginLeft: "auto",
                                  marginBottom: "10px",
                                }
                          }
                          onClick={handlePublishOpen}
                        >
                          {t("Publish_now")}
                        </CircleBtn>
                      </Tooltip>
                      <Modal
                        open={openPublish}
                        onClose={handlePublishClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={style}>
                          <PopUpContainer>
                            <h2>{t("Confirm_publish")}</h2>
                            <p>
                              {t(
                                "Publish_campaigns_and_start_downloading_ads_to_cars?"
                              )}
                            </p>
                            <div className="action-btn">
                              <button
                                onClick={handlePublishReq}
                                className="primary"
                              >
                                {t("Yes")}
                              </button>
                              <button onClick={handlePublishClose}>
                                {t("No")}
                              </button>
                            </div>
                          </PopUpContainer>
                        </Box>
                      </Modal>
                    </>
                  ) : (
                    <></>
                  )}
                </div>

                <CalendarSection
                  convertedData={campaign}
                  campaignData={campaignData}
                />
              </DataSection>
            ) : (
              <CenteredLoader>
                <Loader />
              </CenteredLoader>
            )}
          </BodySection>
        </Section>
      </Wrapper>
    </Container>
  );
};

export default Campaigns;
